window.addEventListener('DOMContentLoaded', function() {
  // make tooltips disappear after their triggering element is clicked
  $(document).on('click', 'button[data-toggle="tooltip"]', function(event) {
    $('.tooltip').fadeOut('fast', function() {$(this).remove()});
  });
});
